module.exports = __webpack_public_path__ + "img/building.e6fb3d96.svg";